import Ma from 'containers/ma/Ma';
import Dashboard from 'containers/ma/Dashboard/Dashboard';
import People from 'containers/ma/People/People';
import Users from 'containers/ma/People/Users/Users';
import List from 'containers/ma/People/List/List';
import Members from 'containers/ma/People/Members/Members';
import Applied from 'containers/ma/People/Applied/Applied';
import { FEATURE_MA_YC_APPLY, FEATURE_REG_OFFER } from 'helpers/features';
import withoutRouteKeys from './withoutRouteKeys';
import Add from '../containers/ma/Add/Add';
import AddHonorary from '../containers/ma/AddHonorary/AddHonorary';
import Profile from '../containers/ma/Profile/Profile';
import Edit from '../containers/ma/Profile/Edit/Edit';
import View from '../containers/ma/Profile/View/View';
import Create from '../containers/ma/MyEvents/Create/Create';
import EventEdit from '../containers/ma/MyEvents/Edit/Edit';
import MyEvents from '../containers/ma/MyEvents/MyEvents';
import Ongoing from '../containers/ma/MyEvents/Ongoing/Ongoing';
import Completed from '../containers/ma/MyEvents/Completed/Completed';
import Cancelled from '../containers/ma/MyEvents/Cancelled/Cancelled';
import Duplicated from '../containers/ma/MyEvents/Duplicated/Duplicated';
import Organisations from '../containers/ma/People/Organisations/Organisations';
import IpmaRegistration from '../containers/ma/IpmaRegistration/IpmaRegistration';
import CpdManagement from '../containers/ma/CpdManagement/CpdManagement';
import Trainings from '../containers/ma/CpdManagement/Trainings/Trainings';
import AddTraining from '../containers/ma/CpdManagement/Trainings/Add/AddTraining';
import EditTraining from '../containers/ma/CpdManagement/Trainings/Edit/EditTraining';
import ImportTraining from '../containers/ma/CpdManagement/Trainings/Import/ImportTraining';
import CpdDiplomas from '../containers/ma/CpdManagement/CpdDiplomas/CpdDiplomas';
import CpdCompetencies from '../containers/ma/CpdManagement/Competencies/Competencies';
import CpdCourses from '../containers/ma/CpdManagement/Courses/Courses';
import Courses from '../containers/ma/Courses/Courses';
import CoursesUnassigned from '../containers/ma/Courses/Unassigned/Unassigned';
import CoursesAssigned from '../containers/ma/Courses/Assigned/Assigned';
import CoursesAccepted from '../containers/ma/Courses/Accepted/Accepted';
import CoursesCanceled from '../containers/ma/Courses/Canceled/Canceled';
import Reports from '../containers/ma/Reports/Reports';
import AddReport from '../containers/ma/Reports/AddReport/AddReport';
import ReadReport from '../containers/ma/Reports/ReadReport/ReadReport';
import EditReport from '../containers/ma/Reports/EditReport/EditReport';
import YoungCrew from '../containers/ma/People/YoungCrew/YoungCrew';
import CpdRequests from '../containers/ma/CpdRequests/CpdRequests';
import Pending from '../containers/ma/CpdRequests/Pending/Pending';
import Accepted from '../containers/ma/CpdRequests/Accepted/Accepted';
import Rejected from '../containers/ma/CpdRequests/Rejected/Rejected';
import ReviewCpdBatch from '../containers/ma/CpdRequests/ReviewCpdBatch/ReviewCpdBatch';
import Cis from '../containers/ma/Cis/Cis';
import CertificateHolders from '../containers/ma/Cis/CertificateHolders/CertificateHolders';
import Certificates from '../containers/ma/Cis/Certificates/Certificates';
import AddCertificateHolder from '../containers/ma/Cis/CertificateHolders/Add/AddCertificateHolder';
import EditCertificateHolder from '../containers/ma/Cis/CertificateHolders/Edit/EditCertificateHolder';
import AddCertificate from '../containers/ma/Cis/Certificates/Add/AddCertificate';
import EditCertificate from '../containers/ma/Cis/Certificates/Edit/EditCertificate';
import RenewCertificate from '../containers/ma/Cis/Certificates/Renew/RenewCertificate';
import CertificationBodyDetails from '../containers/ma/Cis/CertificationBodies/CertificationBodyDetails/CertificationBodyDetails';
import CertificationReports from '../containers/ma/Cis/CertificationReports/CertificationReports';
import CertificationReportForm from '../containers/ma/Cis/CertificationReports/Form/CertificationReportForm';
import Forecasts from '../containers/ma/Cis/Forecasts/Forecasts';
import AddForecast from '../containers/ma/Cis/Forecasts/Add/AddForecast';
import EditForecast from '../containers/ma/Cis/Forecasts/Edit/EditForecast';
import ImportCertificateHolders from '../containers/ma/Cis/CertificateHolders/Import/ImportCertificateHolder';
import UnknownImports from '../containers/ma/Cis/UnknownImports/UnknownImports';
import EditUnknownImport from '../containers/ma/Cis/UnknownImports/Edit/EditUnknownImport';
import Signatures from '../containers/ma/Cis/Signatures/Signatures';
import AddSignature from '../containers/ma/Cis/Signatures/Add/AddSignature';
import EditSignature from '../containers/ma/Cis/Signatures/Edit/EditSignature';
import ClaimedCertificates from '../containers/ma/Certificates/Certificates';
import Pm4np from '../containers/ma/Pm4np/Pm4np';
import ExportCertificatesReport from '../containers/ma/Cis/Certificates/ExportReport/ExportCertificatesReport';
import ChangeRequests from '../containers/ma/Cis/ChangeRequests/ChangeRequests';
import ViewChangeRequest from '../containers/ma/Cis/ChangeRequests/View/ViewChangeRequest';
import EditChangeRequest from '../containers/ma/Cis/ChangeRequests/Edit/EditChangeRequest';
import AddChangeRequest from '../containers/ma/Cis/ChangeRequests/Add/AddChangeRequest';
import Meetings from '../containers/ma/Meetings/Meetings';
import MeetingsList from '../containers/ma/Meetings/MeetingsList/MeetingsList';
import MeetingProxies from '../containers/ma/Meetings/Proxies/Proxies';
import MeetingApplication from '../containers/ma/Meetings/Application/Application';
import MeetingApplications from '../containers/ma/Meetings/Applications/Applications';

const MA = 'maBase';
const DASHBOARD = 'maDashboard';
const PEOPLE = 'maPeople';
const USERS_LIST = 'maUsersList';
const ORGANISATIONS_LIST = 'maOrganisationList';
const PEOPLE_LIST = 'maPeopleList';
const PEOPLE_MEMBERS = 'maPeopleMembers';
const PEOPLE_APPLIED = 'maPeopleApplied';
const PEOPLE_YC = 'maPeopleYc';
const PEOPLE_ADD = 'maPeopleAdd';
const PEOPLE_ADD_HONORARY = 'maPeopleAddHonorary';
const PROFILE = 'maProfile';
const PROFILE_EDIT = 'maProfilEdit';
const PROFILE_VIEW = 'maProfileView';
const MYEVENTS = 'maMyEvents';
const MYEVENTS_ONGOING = 'maMyEventsOngoing';
const MYEVENTS_COMPLETED = 'maMyEventsCompleted';
const MYEVENTS_CANCELLED = 'maMyEventsCancelled';
const MYEVENTS_DUPLICATED = 'maMyEventsDuplicated';
const MYEVENTS_CREATE = 'maMyEventsCreate';
const MYEVENTS_EDIT = 'maMyEventsEdit';
const IPMA_REGISTRATION = 'maIpmaRegistration';
const CPD_MANAGEMENT = 'maCpdManagement';
const CPD_MANAGEMENT_TRAININGS = 'maCpdManagementTrainings';
const CPD_MANAGEMENT_TRAININGS_ADD = 'maCpdManagementTrainingsAdd';
const CPD_MANAGEMENT_TRAININGS_EDIT = 'maCpdManagementTrainingsEdit';
const CPD_MANAGEMENT_TRAININGS_IMPORT = 'maCpdManagementTrainingsImport';
const CPD_MANAGEMENT_CPD_DIPLOMAS = 'maCpdManagementCpdDiplomas';
const CPD_MANAGEMENT_COMPETENCIES = 'maCpdManagementCompetencies';
const CPD_MANAGEMENT_COURSES = 'maCpdManagementCourses';
const COURSES = 'maCourses';
const COURSES_UNASSIGNED = 'maCoursesUnassigned';
const COURSES_ASSIGNED = 'maCoursesAssigned';
const COURSES_ACCEPTED = 'maCoursesAccepted';
const COURSES_CANCELED = 'maCoursesCanceled';
const REPORTS = 'maReports';
const ADD_REPORT = 'maAddReport';
const READ_REPORT = 'maReadReport';
const EDIT_REPORT = 'maEditReport';
const CPD_REQUESTS = 'maCpdRequests';
const CPD_REQUESTS_PENDING = 'maCpdRequestsPending';
const CPD_REQUESTS_ACCEPTED = 'maCpdRequestsAccepted';
const CPD_REQUESTS_REJECTED = 'maCpdRequestsRejected';
const REVIEW_CPD_BATCH = 'maReviewCpdBatch';
const CIS = 'Cis';
const CIS_CERTIFICATES = 'cisCertificates';
const CIS_CERTIFICATES_ADD = 'addcisCertificate';
const CIS_CERTIFICATES_EDIT = 'editcisCertificate';
const CIS_CERTIFICATES_RENEW = 'renewCisCertificate';
const CIS_CERTIFICATE_HOLDERS = 'cisCertificateHolders';
const CIS_CERTIFICATE_HOLDERS_ADD = 'addCisCertificateHolders';
const CIS_CERTIFICATE_HOLDERS_EDIT = 'editCisCertificateHolders';
const CIS_CERTIFICATION_BODY_DETAILS = 'cisCertificationBodyDetails';
const CIS_FORECASTS = 'cisForecasts';
const CIS_FORECASTS_ADD = 'addCisForecast';
const CIS_FORECASTS_EDIT = 'editCisForecast';
const CIS_CERTIFICATE_HOLDERS_IMPORT = 'importCisCertificateHolders';
const CIS_CERTIFICATION_REPORTS = 'cisCertificationReports';
const CIS_CERTIFICATION_REPORT_ADD = 'cisCertificationReportAdd';
const CIS_CERTIFICATION_REPORT_EDIT = 'cisCertificationReportEdit';
const CIS_CERTIFICATION_REPORT_VIEW = 'cisCertificationReportView';
const CIS_IMPORTER_UNKNOWN = 'cisUnknownImports';
const CIS_IMPORTER_UNKNOWN_EDIT = 'cisUnknownImportsEdit';
const CIS_SIGNATURES = 'cisSignatures';
const CIS_SIGNATURES_ADD = 'addCisSignatures';
const CIS_SIGNATURES_EDIT = 'editCisSignatures';
const CB_CLAIMED_CERTIFICATES_VIEW = 'cbClaimedCertificatesView';
const PM4NP = 'maPm4np';
const CIS_CERTIFICATES_EXPORT_REPORT = 'cisCertificatesExportReport';
const CIS_CHANGE_REQUESTS = 'cisChangeRequests';
const CIS_CHANGE_REQUESTS_VIEW = 'cisChangeRequestsView';
const CIS_CHANGE_REQUESTS_EDIT = 'cisChangeRequestsEdit';
const CIS_CHANGE_REQUESTS_DELETE = 'cisChangeRequestsDelete';
const CIS_CHANGE_REQUESTS_CREATE = 'cisChangeRequestsCreate';
const MEETINGS = 'maMeetings';
const MEETINGS_COD = 'maMeetingsCod';
const MEETINGS_COD_APPLICATIONS = 'maMeetingsCodApplications';
const MEETINGS_CSP_APPLICATIONS = 'maMeetingsCspApplications';
const MEETINGS_CSP = 'maMeetingsCsp';
const MEETINGS_PROXIES = 'maMeetingsProxies';
const MEETINGS_COD_APPLICATION_CREATE = 'maMeetingsCodApplicationCreate';
const MEETINGS_COD_APPLICATION_EDIT = 'maMeetingsCodApplicationEdit';
const MEETINGS_COD_APPLICATION_VIEW = 'maMeetingsCodApplicationView';
const MEETINGS_CSP_APPLICATION_CREATE = 'maMeetingsCspApplicationCreate';
const MEETINGS_CSP_APPLICATION_EDIT = 'maMeetingsCspApplicationEdit';
const MEETINGS_CSP_APPLICATION_VIEW = 'maMeetingsCspApplicationView';

const routes = [
  {
    key: MA,
    path: '/ma',
    component: Ma,
    exact: false,
    withAuth: true,
    permissions: {
      appType: 'ma',
    },
    routes: [
      {
        key: DASHBOARD,
        path: '/ma',
        component: Dashboard,
        exact: true,
        withAuth: false,
      },
      {
        key: PEOPLE_ADD,
        path: '/ma/people/add',
        component: Add,
        exact: false,
        withAuth: false,
      },
      {
        // Its own screen: granting an Honorary Fellowship searches different people and offers a
        // smaller set of positions than taking on one of the association's own officers.
        key: PEOPLE_ADD_HONORARY,
        path: '/ma/people/honorary/add',
        component: AddHonorary,
        exact: true,
        withAuth: false,
      },
      {
        key: CB_CLAIMED_CERTIFICATES_VIEW,
        path: '/ma/certificates',
        component: ClaimedCertificates,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_manage_cis'],
        },
      },
      {
        // No permissions on the meeting routes on purpose: a user without the
        // right still reaches the screen, which explains the missing access in
        // a modal and sends them back, instead of the entry disappearing.
        key: MEETINGS,
        path: '/ma/meetings',
        component: Meetings,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: MEETINGS_COD_APPLICATIONS,
            path: '/ma/meetings/cod/applications/:meetingId',
            component: MeetingApplications,
            meetingType: 'cod',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_CSP_APPLICATIONS,
            path: '/ma/meetings/csp/applications/:meetingId',
            component: MeetingApplications,
            meetingType: 'csp',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_COD_APPLICATION_CREATE,
            path: '/ma/meetings/cod/application/create/:meetingId',
            component: MeetingApplication,
            meetingType: 'cod',
            mode: 'create',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_COD_APPLICATION_EDIT,
            path: '/ma/meetings/cod/application/:applicationId/edit',
            component: MeetingApplication,
            meetingType: 'cod',
            mode: 'edit',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_COD_APPLICATION_VIEW,
            path: '/ma/meetings/cod/application/:applicationId/view',
            component: MeetingApplication,
            meetingType: 'cod',
            mode: 'view',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_COD,
            path: '/ma/meetings/cod',
            component: MeetingsList,
            meetingType: 'cod',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_CSP_APPLICATION_CREATE,
            path: '/ma/meetings/csp/application/create/:meetingId',
            component: MeetingApplication,
            meetingType: 'csp',
            mode: 'create',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_CSP_APPLICATION_EDIT,
            path: '/ma/meetings/csp/application/:applicationId/edit',
            component: MeetingApplication,
            meetingType: 'csp',
            mode: 'edit',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_CSP_APPLICATION_VIEW,
            path: '/ma/meetings/csp/application/:applicationId/view',
            component: MeetingApplication,
            meetingType: 'csp',
            mode: 'view',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_CSP,
            path: '/ma/meetings/csp',
            component: MeetingsList,
            meetingType: 'csp',
            exact: false,
            withAuth: false,
          },
          {
            key: MEETINGS_PROXIES,
            path: '/ma/meetings/proxies',
            component: MeetingProxies,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: CIS,
        path: '/ma/cis',
        component: Cis,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_manage_cis', 'ma_cb_head_cis'],
        },
        routes: [
          {
            key: CIS_CERTIFICATE_HOLDERS_ADD,
            path: '/ma/cis/certificate-holders/create',
            component: AddCertificateHolder,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS_EDIT,
            path: '/ma/cis/certificate-holders/edit',
            component: EditCertificateHolder,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS_IMPORT,
            path: '/ma/cis/certificate-holders/import',
            component: ImportCertificateHolders,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATE_HOLDERS,
            path: '/ma/cis/certificate-holders',
            component: CertificateHolders,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATES_ADD,
            path: '/ma/cis/certificates/create',
            component: AddCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_EDIT,
            path: '/ma/cis/certificates/edit',
            component: EditCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_RENEW,
            path: '/ma/cis/certificates/renew',
            component: RenewCertificate,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATES_EXPORT_REPORT,
            path: '/ma/cis/certificates/export-report',
            component: ExportCertificatesReport,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATES,
            path: '/ma/cis/certificates',
            component: Certificates,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_SIGNATURES_ADD,
            path: '/ma/cis/signatures/create',
            component: AddSignature,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
              key: CIS_SIGNATURES_EDIT,
            path: '/ma/cis/signatures/edit',
            component: EditSignature,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_SIGNATURES,
            path: '/ma/cis/signatures',
            component: Signatures,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATION_BODY_DETAILS,
            path: '/ma/cis/certification-bodies/details',
            component: CertificationBodyDetails,
            exact: true,
            withAuth: false,
          },
          {
            key: CIS_FORECASTS_ADD,
            path: '/ma/cis/forecasts/create',
            component: AddForecast,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_FORECASTS_EDIT,
            path: '/ma/cis/forecasts/edit',
            component: EditForecast,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_FORECASTS,
            path: '/ma/cis/forecasts',
            component: Forecasts,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CHANGE_REQUESTS_VIEW,
            path: '/ma/cis/change-requests/view',
            component: ViewChangeRequest,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CHANGE_REQUESTS_EDIT,
            path: '/ma/cis/change-requests/edit',
            component: EditChangeRequest,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CHANGE_REQUESTS_CREATE,
            path: '/ma/cis/change-requests/create',
            component: AddChangeRequest,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CHANGE_REQUESTS,
            path: '/ma/cis/change-requests',
            component: ChangeRequests,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_IMPORTER_UNKNOWN_EDIT,
            path: '/ma/cis/unknown-imports/edit',
            component: EditUnknownImport,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_IMPORTER_UNKNOWN,
            path: '/ma/cis/unknown-imports',
            component: UnknownImports,
            exact: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATION_REPORT_ADD,
            path: '/ma/cis/reports/create',
            component: CertificationReportForm,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATION_REPORT_EDIT,
            path: '/ma/cis/reports/edit',
            component: CertificationReportForm,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_cis'],
            },
          },
          {
            key: CIS_CERTIFICATION_REPORT_VIEW,
            path: '/ma/cis/reports/view',
            component: CertificationReportForm,
            exact: false,
            withAuth: false,
          },
          {
            key: CIS_CERTIFICATION_REPORTS,
            path: '/ma/cis/reports',
            component: CertificationReports,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: PEOPLE,
        path: '/ma/people',
        component: People,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: USERS_LIST,
            path: '/ma/people/users',
            component: Users,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_members_ma_user_list'],
            },
          },
          {
            key: ORGANISATIONS_LIST,
            path: '/ma/people/organisations',
            component: Organisations,
            exact: false,
            withAuth: false,
          },
          {
            key: PEOPLE_LIST,
            path: '/ma/people/list',
            component: List,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_members_people'],
            },
          },
          {
            key: PEOPLE_MEMBERS,
            path: '/ma/people/members',
            component: Members,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_members_people'],
            },
          },
          {
            key: PEOPLE_APPLIED,
            path: '/ma/people/applied',
            component: Applied,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_members_people'],
            },
          },
          {
            key: PEOPLE_YC,
            path: '/ma/people/youngcrew',
            component: YoungCrew,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_manage_members_people'],
            },
          },
        ],
      },
      {
        key: PROFILE,
        path: '/ma/profile',
        component: Profile,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: PROFILE_EDIT,
            path: '/ma/profile/edit',
            component: Edit,
            exact: false,
            withAuth: false,
            permissions: {
              roles: ['ma_my_ma_edit_ma_profil'],
            },
          },
          {
            key: PROFILE_VIEW,
            path: '/ma/profile/view',
            component: View,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: MYEVENTS,
        path: '/ma/my-events',
        component: MyEvents,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: MYEVENTS_ONGOING,
            path: '/ma/my-events/ongoing',
            component: Ongoing,
            exact: false,
            withAuth: false,
          },
          {
            key: MYEVENTS_COMPLETED,
            path: '/ma/my-events/completed',
            component: Completed,
            exact: false,
            withAuth: false,
          },
          {
            key: MYEVENTS_CANCELLED,
            path: '/ma/my-events/cancelled',
            component: Cancelled,
            exact: false,
            withAuth: false,
          },
          {
            key: MYEVENTS_DUPLICATED,
            path: '/ma/my-events/duplicated',
            component: Duplicated,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: MYEVENTS_CREATE,
        path: '/ma/event/create/:id',
        component: Create,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_my_events_create_event'],
        },
      },
      {
        key: MYEVENTS_CREATE,
        path: '/ma/event/create',
        component: Create,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_my_events_create_event'],
        },
      },
      {
        key: MYEVENTS_EDIT,
        path: '/ma/event/:id/edit',
        component: EventEdit,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_my_events_edit_event'],
        },
      },
      {
        key: IPMA_REGISTRATION,
        path: '/ma/ipma-registration',
        component: IpmaRegistration,
        exact: false,
        withAuth: false,
      },
      {
        key: CPD_MANAGEMENT,
        path: '/ma/cpd-management',
        component: CpdManagement,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_manage_cpd'],
        },
        routes: [
          {
            key: CPD_MANAGEMENT_TRAININGS_ADD,
            path: '/ma/cpd-management/trainings/create',
            component: AddTraining,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_TRAININGS_EDIT,
            path: '/ma/cpd-management/trainings/edit',
            component: EditTraining,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_TRAININGS_IMPORT,
            path: '/ma/cpd-management/trainings/import',
            component: ImportTraining,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_TRAININGS,
            path: '/ma/cpd-management/trainings',
            component: Trainings,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_CPD_DIPLOMAS,
            path: '/ma/cpd-management/cpd-diplomas',
            component: CpdDiplomas,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_COMPETENCIES,
            path: '/ma/cpd-management/competencies',
            component: CpdCompetencies,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_MANAGEMENT_COURSES,
            path: '/ma/cpd-management/courses',
            component: CpdCourses,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: COURSES,
        path: '/ma/courses',
        component: Courses,
        exact: false,
        withAuth: false,
        routes: [
          {
            key: COURSES_UNASSIGNED,
            path: '/ma/courses/unassigned',
            component: CoursesUnassigned,
            exact: false,
            withAuth: false,
          },
          {
            key: COURSES_ASSIGNED,
            path: '/ma/courses/assigned',
            component: CoursesAssigned,
            exact: false,
            withAuth: false,
          },
          {
            key: COURSES_ACCEPTED,
            path: '/ma/courses/accepted',
            component: CoursesAccepted,
            exact: false,
            withAuth: false,
          },
          {
            key: COURSES_CANCELED,
            path: '/ma/courses/canceled',
            component: CoursesCanceled,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: REPORTS,
        path: '/ma/reports',
        component: Reports,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_send_members_report'],
        },
      },
      {
        key: ADD_REPORT,
        path: '/ma/add-report',
        component: AddReport,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_send_members_report'],
        },
      },
      {
        key: READ_REPORT,
        path: '/ma/read-report/:id',
        component: ReadReport,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_send_members_report'],
        },
      },
      {
        key: EDIT_REPORT,
        path: '/ma/edit-report/:id',
        component: EditReport,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_send_members_report'],
        },
      },
      {
        key: CPD_REQUESTS,
        path: '/ma/cpd-requests',
        component: CpdRequests,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_manage_cpd'],
        },
        routes: [
          {
            key: CPD_REQUESTS_PENDING,
            path: '/ma/cpd-requests/pending',
            component: Pending,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_REQUESTS_ACCEPTED,
            path: '/ma/cpd-requests/accepted',
            component: Accepted,
            exact: false,
            withAuth: false,
          },
          {
            key: CPD_REQUESTS_REJECTED,
            path: '/ma/cpd-requests/rejected',
            component: Rejected,
            exact: false,
            withAuth: false,
          },
        ],
      },
      {
        key: REVIEW_CPD_BATCH,
        path: '/ma/cpd-request/:id',
        component: ReviewCpdBatch,
        exact: false,
        withAuth: false,
        permissions: {
          roles: ['ma_manage_cpd'],
        },
      },
      {
        key: PM4NP,
        path: '/ma/pm4np',
        component: Pm4np,
        exact: false,
        withAuth: false,
      },
    ],
  },
];

// Routes belonging to a feature that is held back until the client releases it.
// Leaving them out of the tree takes away both the screen and the tab that
// leads to it; the API closes the endpoints behind them in the same way.
const heldBack = [
  ...(FEATURE_MA_YC_APPLY ? [] : [PEOPLE_APPLIED]),
  ...(FEATURE_REG_OFFER ? [] : [IPMA_REGISTRATION, CPD_MANAGEMENT]),
];

export default withoutRouteKeys(routes, heldBack);
